var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.78289 0 4.26562 3.39703 4.26562 7.73438C4.26562 9.38447 4.76147 10.8559 5.71308 12.2347L11.4081 21.1212C11.6844 21.5532 12.3162 21.5524 12.5919 21.1212L18.3116 12.2044C19.2428 10.8881 19.7344 9.34252 19.7344 7.73438C19.7344 3.46964 16.2647 0 12 0ZM12 11.25C10.0616 11.25 8.48438 9.6728 8.48438 7.73438C8.48438 5.79595 10.0616 4.21875 12 4.21875C13.9384 4.21875 15.5156 5.79595 15.5156 7.73438C15.5156 9.6728 13.9384 11.25 12 11.25Z",
    fill: "url(#paint0_linear_1092_3798)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4967 16.1575L13.9562 21.6928C13.0398 23.1216 10.9551 23.117 10.0431 21.6942L6.49678 16.1589C3.37659 16.8803 1.45312 18.2019 1.45312 19.7811C1.45312 22.5215 6.88725 23.9999 12 23.9999C17.1128 23.9999 22.5469 22.5215 22.5469 19.7811C22.5469 18.2008 20.6207 16.8785 17.4967 16.1575Z",
    fill: "url(#paint1_linear_1092_3798)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1092_3798",
    x1: 4.48156,
    y1: 17.1559,
    x2: 19.7344,
    y2: 17.1559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1092_3798",
    x1: 1.74758,
    y1: 22.4314,
    x2: 22.5469,
    y2: 22.4314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIc);
export default __webpack_public_path__ + "static/media/location_ic.a5d8614f8d4668d29c6b9edd1eb47c52.svg";
export { ForwardRef as ReactComponent };